import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getLastIdGranularStep } from '../../utils';
import { updateDevelopmentalRubricDialog } from '../../../../../store/actions/developmental-rubrics.actions';
import { useParams } from 'react-router-dom';
import CardGranularStep from './CardGranularStep';
import CardLevel from './CardLevel';
import DialogWorkedExamples from '../FormWorkedExamples/DialogWorkedExamples';

const CardsGranularSteps = ({ lcs = [], type }) => {
  const { id: drId } = useParams();
  const dispatch = useDispatch();
  const [modal, setModal] = useState(null);

  const currentCurriculum = useSelector((state) => state?.assessment?.currentCurriculum || {});
  const minMarking = currentCurriculum?.marking?.find((item) => item.minValue) || {};
  let levelsId = [];
  lcs.forEach((lc) => {
    const lvls = lc.granularSteps?.filter((step) => step.definition).map((step) => step.levelId);
    levelsId = [...levelsId, ...lvls];
  });
  levelsId = [...new Set(levelsId)];
  const levelsRender = currentCurriculum?.levels
    ?.filter((item) => levelsId.includes(item._id))
    .sort((a, b) => b.position - a.position);

  const onAddGranularStep = (lcId, levelId, nextLevel = {}) => {
    const lc = lcs.find((item) => item._id === lcId);
    if (!lc) {
      return;
    }

    const currentGranularSteps = lc.granularSteps.filter((step) => step.levelId === levelId);
    const lastId = getLastIdGranularStep(currentGranularSteps);
    const gsId = `level-${levelId}-gs-${lastId}`;
    const newGranularStep = {
      id: gsId,
      _id: gsId,
      levelId,
      isLevel: false,
      definition: '',
      descriptor: `Working towards ${nextLevel?.name}`,
      workedExamples: [],
      drId,
      lcId,
      gsId
    };
    dispatch(updateDevelopmentalRubricDialog(true, 'created-granular-step', newGranularStep));
  };

  const onUpdateGranularStep = (lcId, levelId, gsId) => {
    const lc = lcs.find((item) => item._id === lcId);
    if (!lc) {
      return;
    }

    const currentGranularSteps = lc.granularSteps.find(
      (step) => step.levelId === levelId && step.id === gsId
    );
    dispatch(
      updateDevelopmentalRubricDialog(true, 'updated-granular-step', {
        ...currentGranularSteps,
        _id: gsId,
        gsId,
        lcId,
        drId
      })
    );
  };

  const onRemoveGranularStep = (lcId, levelId, gsId) => {
    const lc = lcs.find((item) => item._id === lcId);
    if (!lc) {
      return;
    }

    const currentGranularSteps = lc.granularSteps.find(
      (step) => step.levelId === levelId && step.id === gsId
    );

    dispatch(
      updateDevelopmentalRubricDialog(true, 'deleted-granular-step', {
        ...currentGranularSteps,
        _id: gsId,
        gsId,
        lcId,
        drId
      })
    );
  };
  return (
    <>
      {levelsRender.map((item, index) => (
        <React.Fragment key={`granular-steps-level-${item._id}`}>
          <CardGranularStep
            lcs={lcs}
            levelId={item._id}
            level={{
              ...item,
              primaryColor: minMarking?.primaryColor,
              secondaryColor: minMarking?.secondaryColor
            }}
            nextLevel={levelsRender[index - 1]}
            onAddGranularStep={onAddGranularStep}
            onRemoveGranularStep={onRemoveGranularStep}
            onUpdateGranularStep={onUpdateGranularStep}
            onWorkedExamples={(form, type) => setModal({ form, type, element: 'worked-examples' })}
            drId={drId}
            type={type}
          />
          <CardLevel
            drId={drId}
            type={type}
            lcs={lcs}
            levelId={item._id}
            level={{
              ...item,
              primaryColor: minMarking?.primaryColor,
              secondaryColor: minMarking?.secondaryColor
            }}
            onWorkedExamples={(form, type, element) => setModal({ form, type, element })}
          />
        </React.Fragment>
      ))}

      {modal && (
        <DialogWorkedExamples
          open={!!modal}
          onClose={() => setModal(null)}
          formData={modal.form}
          onSave={() => {}}
          type={`${modal.type}-granular-step`}
          element={modal.element ? modal.element : 'worked-examples'}
        />
      )}
    </>
  );
};

export default CardsGranularSteps;
